<div class="pm-head">
  @if (photo) {
    <span class="pm-avatar" [style.background-image]="'url(' + photo + ')'"></span>
  } @else {
    <span class="pm-avatar pm-avatar--mono">{{ initial }}</span>
  }
  <span class="pm-name" [title]="name">{{ name }}</span>
</div>

<div class="pm-list">
  @if (!billingInvalid) {
    <a class="pm-item" id="EditProfile" routerLink="/profile/" (click)="menuClose.emit()">
      <svg class="pm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21a8 8 0 0 1 16 0" />
      </svg>
      <span class="pm-label">Edit profile</span>
    </a>

    <a class="pm-item" id="PersonalSettings" routerLink="/user-settings/" (click)="menuClose.emit()">
      <svg class="pm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="4" x2="4" y1="21" y2="14" /><line x1="4" x2="4" y1="10" y2="3" />
        <line x1="12" x2="12" y1="21" y2="12" /><line x1="12" x2="12" y1="8" y2="3" />
        <line x1="20" x2="20" y1="21" y2="16" /><line x1="20" x2="20" y1="12" y2="3" />
        <line x1="2" x2="6" y1="14" y2="14" /><line x1="10" x2="14" y1="8" y2="8" /><line x1="18" x2="22" y1="16" y2="16" />
      </svg>
      <span class="pm-label">Personal settings</span>
    </a>

    <div class="pm-divider" aria-hidden="true"></div>
  }

  <div class="pm-ctl">
    <span class="pm-ctl__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 3a9 9 0 0 1 0 18Z" fill="currentColor" stroke="none" />
      </svg>
    </span>
    <span class="pm-ctl__label">Theme</span>
    <div class="pm-theme__seg" role="group" aria-label="Theme" (click)="$event.stopPropagation()">
      <button type="button" class="pm-seg" [class.is-active]="theme === 'auto'" (click)="pickTheme('auto')" aria-label="System" [attr.aria-pressed]="theme === 'auto'" matTooltip="System" matTooltipShowDelay="300">
        <svg style="color: #14b8a6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <rect width="20" height="14" x="2" y="3" rx="2" />
          <line x1="8" x2="16" y1="21" y2="21" /><line x1="12" x2="12" y1="17" y2="21" />
        </svg>
      </button>
      <button type="button" class="pm-seg" [class.is-active]="theme === 'false'" (click)="pickTheme('false')" aria-label="Light" [attr.aria-pressed]="theme === 'false'" matTooltip="Light" matTooltipShowDelay="300">
        <svg style="color: #f5a623" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2" /><path d="M12 20v2" /><path d="m4.93 4.93 1.41 1.41" /><path d="m17.66 17.66 1.41 1.41" />
          <path d="M2 12h2" /><path d="M20 12h2" /><path d="m6.34 17.66-1.41 1.41" /><path d="m19.07 4.93-1.41 1.41" />
        </svg>
      </button>
      <button type="button" class="pm-seg" [class.is-active]="theme === 'true'" (click)="pickTheme('true')" aria-label="Dark" [attr.aria-pressed]="theme === 'true'" matTooltip="Dark" matTooltipShowDelay="300">
        <svg style="color: #8b5cf6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
        </svg>
      </button>
    </div>
  </div>

  <div class="pm-ctl">
    <span class="pm-ctl__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2" />
        <path d="M6.453 15h11.094" />
        <path d="M8.5 2h7" />
      </svg>
    </span>
    <span class="pm-ctl__label">Beta features</span>
    <button
      type="button"
      role="switch"
      class="nf-switch"
      [class.is-on]="betaEnabled"
      [attr.aria-checked]="betaEnabled"
      (click)="onBetaClick($event)"
      id="ProfileBetaToggle">
      <span class="nf-switch__knob"></span>
    </button>
  </div>

  <div class="pm-divider" aria-hidden="true"></div>

  <button type="button" class="pm-item pm-item--logout" id="LogoutButton" (click)="logout.emit()">
    <svg class="pm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="m16 17 5-5-5-5" />
      <path d="M21 12H9" />
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    </svg>
    <span class="pm-label">Log out</span>
  </button>
</div>
